import { initializeApp, type FirebaseApp, type FirebaseOptions } from 'firebase/app';

import type { FirebaseEnvT } from '../config/env';

export type FirebaseAppEnvT = Readonly<{
  firebase: FirebaseEnvT | FirebaseOptions;
}>;

export function createFirebaseApp(env: FirebaseAppEnvT): FirebaseApp {
  return initializeApp(env.firebase);
}
